import { Tabs, TabsList, TabsTrigger, TabsContent } from '@components/ui';
import { BuildingOfficeIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { CompanyInfoTab } from './CompanyInfoTab';
import { RequestLogsTab } from './RequestLogsTab';

export function DevToolsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-secondary-900 dark:text-white">Herramientas de Desarrollo</h1>
        <p className="mt-2 text-secondary-600 dark:text-secondary-400">
          Información de la compañía y registros de las solicitudes que el portal envía al backend.
        </p>
      </div>

      <Tabs defaultValue="company">
        <TabsList data-testid="devtools-tabs-list">
          <TabsTrigger value="company" data-testid="devtools-tab-company-trigger">
            <span className="inline-flex items-center gap-2">
              <BuildingOfficeIcon className="w-4 h-4" />
              Información de la compañía
            </span>
          </TabsTrigger>
          <TabsTrigger value="logs" data-testid="devtools-tab-logs-trigger">
            <span className="inline-flex items-center gap-2">
              <DocumentTextIcon className="w-4 h-4" />
              Registros de solicitudes
            </span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="company" data-testid="devtools-tab-company-content">
          <CompanyInfoTab />
        </TabsContent>
        <TabsContent value="logs" data-testid="devtools-tab-logs-content">
          <RequestLogsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
